export const MediaType = {
    IMAGE: 'image',
    MP3: 'mp3',
    MP4: 'mp4',
    TEXT: 'text',
    HTML: 'html'
};
export const EasingIn = {
    NONE: 'None',
    STACK: 'Stack',
    FADE: 'Fade',
    CROSS_FADE: 'Cross Fade',
    SLIDE_IN_LEFT: 'Slide In Left',
    SLIDE_IN_RIGHT: 'Slide In Right',
    SLIDE_IN_UP: 'Slide In Up',
    SLIDE_IN_DOWN: 'Slide In Down',
    SCALE_IN: 'Scale In',
    ZOOM_IN: 'Zoom In'
};
export const EasingOut = {
    NONE: 'None',
    STACK: 'Stack',
    FADE: 'Fade',
    CROSS_FADE: 'Cross Fade',
    SLIDE_OUT_LEFT: 'Slide Out Left',
    SLIDE_OUT_RIGHT: 'Slide Out Right',
    SLIDE_OUT_UP: 'Slide Out Up',
    SLIDE_OUT_DOWN: 'Slide Out Down',
    SCALE_OUT: 'Scale Out',
    ZOOM_OUT: 'Zoom Out'
};
export const EASING_IN_OPTIONS = [
    EasingIn.NONE,
    EasingIn.CROSS_FADE,
    EasingIn.FADE,
    EasingIn.SCALE_IN,
    EasingIn.SLIDE_IN_DOWN,
    EasingIn.SLIDE_IN_LEFT,
    EasingIn.SLIDE_IN_RIGHT,
    EasingIn.SLIDE_IN_UP,
    EasingIn.STACK,
    EasingIn.ZOOM_IN
];
export const EASING_OUT_OPTIONS = [
    EasingOut.NONE,
    EasingOut.CROSS_FADE,
    EasingOut.FADE,
    EasingOut.SCALE_OUT,
    EasingOut.SLIDE_OUT_DOWN,
    EasingOut.SLIDE_OUT_LEFT,
    EasingOut.SLIDE_OUT_RIGHT,
    EasingOut.SLIDE_OUT_UP,
    EasingOut.STACK,
    EasingOut.ZOOM_OUT
];
